document.addEventListener("DOMContentLoaded", function () {
  const mobileToggle = document.querySelector(".mobile-toggle");
  const navCategories = document.querySelector(".nav-categories");
  const megaMenu = document.querySelector(".mega-menu");
  const mobileBack = document.querySelector(".mobile-back");
  const mobileClose = document.querySelector(".mobile-close");
  const mobileTitle = document.querySelector(".mobile-title");
  const caret = document.querySelector(".caretStyle");
  let currentLevel = 1;
  let navigationStack = [];

  // Mobile menu toggle
  mobileToggle?.addEventListener("click", () => {
    navCategories.classList.add("active");
    document.body.classList.add("menu-open");
    mobileTitle.textContent = "Equipment";
    mobileBack.classList.remove("visible");
  });

  // Mobile close button
  mobileClose?.addEventListener("click", () => {
    navCategories.classList.remove("active");
    megaMenu.classList.remove("active");
    document.body.classList.remove("menu-open");
    resetNavigation();
  });

  // Equipment menu trigger - MODIFIED to use click only
  const equipmentTrigger = document.querySelector(".equipment-trigger");

  if (equipmentTrigger) {
    // Removed mouseenter event

    equipmentTrigger.addEventListener("click", function (e) {
      e.preventDefault();

      // Toggle the active class instead of just adding it
      if (megaMenu.classList.contains("active")) {
        megaMenu.classList.remove("active");
      } else {
        megaMenu.classList.add("active");
      }

      if (window.innerWidth <= 768) {
        mobileBack.classList.add("visible");
        mobileTitle.textContent = "Categories";
      }

      resetNavigation();
    });
  }

  // Removed mouseleave event for mega menu

  // Category list navigation - improved to better handle desktop/mobile
  document
    .querySelector(".category-list")
    ?.addEventListener("click", function (e) {
      const link = e.target.closest("a[data-category]");
      if (link) {
        e.preventDefault();
        const category = link.dataset.category;
        const categoryName = link.textContent.trim();
        const isMobile = window.innerWidth <= 768;

        document
          .querySelectorAll(".category-list a")
          .forEach((a) => a.classList.remove("active"));
        link.classList.add("active");

        // First reset all subcategory content
        document.querySelectorAll(".subcategory-content").forEach((content) => {
          content.classList.remove("active");

          // Only apply transform on mobile
          if (isMobile) {
            content.style.transform = "translateX(-100%)";
          } else {
            // Clear transforms on desktop
            content.style.transform = "";
          }
        });

        // Find and activate target content
        const targetContent = document.querySelector(
          `.subcategory-content[data-category="${category}"]`
        );

        if (targetContent) {
          targetContent.classList.add("active");

          // Only apply transform on mobile
          if (isMobile) {
            targetContent.style.transform = "translateX(0)";
          }
        }

        if (isMobile) {
          mobileTitle.textContent = categoryName;
        }

        navigationStack = [{ category, level: 2, title: categoryName }];
      }
    });

  // Add this window load event to reset initial state
  window.addEventListener("load", () => {
    const isMobile = window.innerWidth <= 768;

    document.querySelectorAll(".subcategory-content").forEach((content) => {
      // Only apply transform on mobile
      if (isMobile) {
        content.style.transform = "translateX(-100%)";
      } else {
        // Clear transforms on desktop
        content.style.transform = "";
      }
    });
  });

  // The rest of your code remains the same...
  // Subcategory navigation for both level 3 and 4
  let subCategoryCurrentLevel = 1;
  const subCategoryNavigationStack = [];

  document.addEventListener("click", function (e) {
    const subcategoryLink = e.target.closest(
      ".subcategory-list a[data-category]"
    );

    if (subcategoryLink && subcategoryLink.classList.contains("has-children")) {
      e.preventDefault();

      const category = subcategoryLink.dataset.category;
      const categoryName = subcategoryLink.textContent.trim();
      const currentSection = subcategoryLink.closest(".subcategory-content");
      const currentLevel = parseInt(
        currentSection.querySelector(".breadcrumb span:last-child").dataset
          .level
      );

      // Handle mobile-specific behavior
      if (window.innerWidth <= 768) {
        mobileTitle.textContent = categoryName;
      }

      // Handle subcategory display
      handleSubCategories(category, currentLevel + 1);

      // Update navigation stack
      subCategoryNavigationStack.push({
        category,
        level: currentLevel + 1,
        title: categoryName,
      });
    }
  });

  function handleSubCategories(category, level) {
    const isMobile = window.innerWidth <= 768;
    const allContents = document.querySelectorAll(".subcategory-content");

    // Reset all contents
    allContents.forEach((content) => {
      content.classList.remove("active");

      // Only apply transform on mobile
      if (isMobile) {
        content.style.transform = "translateX(-100%)";
      } else {
        // Clear transforms on desktop
        content.style.transform = "";
      }
    });

    // Activate target content
    const targetContent = document.querySelector(
      `.subcategory-content[data-category="${category}"]`
    );

    if (targetContent) {
      targetContent.classList.add("active");

      // Only apply transform on mobile
      if (isMobile) {
        targetContent.style.transform = "translateX(0)";
      }

      subCategoryCurrentLevel = level;
    }
  }

  // Subcategory navigation for both level 3 and 4
  document.addEventListener("click", function (e) {
    const subcategoryLink = e.target.closest(
      ".subcategory-list a[data-category]"
    );
    if (subcategoryLink && subcategoryLink.classList.contains("has-children")) {
      e.preventDefault();
      const category = subcategoryLink.dataset.category;
      const categoryName = subcategoryLink.textContent.trim();
      const currentSection = subcategoryLink.closest(".subcategory-content");
      const currentLevel = parseInt(
        currentSection.querySelector(".breadcrumb span:last-child").dataset
          .level
      );

      if (window.innerWidth <= 768) {
        mobileTitle.textContent = categoryName;
      }

      showSubcategories(category, currentLevel + 1);
      navigationStack.push({
        category,
        level: currentLevel + 1,
        title: categoryName,
      });
    }
  });

  // Update this event listener in your code
  document.addEventListener("click", function (e) {
    const subcategoryLink = e.target.closest(
      ".subcategory-list a[data-category]"
    );
    if (subcategoryLink && subcategoryLink.classList.contains("has-children")) {
      e.preventDefault();
      const category = subcategoryLink.dataset.category;
      const categoryName = subcategoryLink.textContent.trim();
      const currentSection = subcategoryLink.closest(".subcategory-content");
      const currentLevel = parseInt(
        currentSection.querySelector(".breadcrumb span:last-child").dataset
          .level
      );
      const isMobile = window.innerWidth <= 768;

      // Reset all subcategory content at the current level
      document.querySelectorAll(".subcategory-content").forEach((content) => {
        content.classList.remove("active");

        // Only apply transform on mobile
        if (isMobile) {
          content.style.transform = "translateX(-100%)";
        } else {
          // Clear transforms on desktop
          content.style.transform = "";
        }
      });

      // Find and activate target content
      const targetContent = document.querySelector(
        `.subcategory-content[data-category="${category}"]`
      );

      if (targetContent) {
        targetContent.classList.add("active");

        // Only apply transform on mobile
        if (isMobile) {
          targetContent.style.transform = "translateX(0)";
        }
      }

      if (isMobile) {
        mobileTitle.textContent = categoryName;
      }

      navigationStack.push({
        category,
        level: currentLevel + 1,
        title: categoryName,
      });
    }
  });

  // Updated showSubcategories function with better mobile/desktop handling
  function showSubcategories(category, level) {
    const isMobile = window.innerWidth <= 768;

    document.querySelectorAll(".subcategory-content").forEach((content) => {
      content.classList.remove("active");

      // Only apply transform on mobile devices
      if (isMobile) {
        content.style.transform = "translateX(-100%)";
      } else {
        // On desktop, remove any transforms to prevent layout issues
        content.style.transform = "";
      }
    });

    const targetContent = document.querySelector(
      `.subcategory-content[data-category="${category}"]`
    );

    if (targetContent) {
      targetContent.classList.add("active");

      // Only apply transform on mobile devices
      if (isMobile) {
        targetContent.style.transform = "translateX(0)";
      }

      currentLevel = level;
    }
  }

  // Breadcrumb navigation
  document.addEventListener("click", function (e) {
    const breadcrumbItem = e.target.closest(".breadcrumb span[data-level]");
    if (breadcrumbItem) {
      const level = parseInt(breadcrumbItem.dataset.level);
      if (!isNaN(level)) {
        navigateToLevel(level);
      }
    }
  });

  // Mobile back navigation
  mobileBack?.addEventListener("click", () => {
    if (navigationStack.length > 0) {
      navigationStack.pop();
      const previousState = navigationStack[navigationStack.length - 1];

      if (previousState) {
        showSubcategories(previousState.category, previousState.level);
        mobileTitle.textContent = previousState.title;
      } else {
        megaMenu.classList.remove("active");
        mobileBack.classList.remove("visible");
        mobileTitle.textContent = "Equipment";
      }
    } else {
      megaMenu.classList.remove("active");
      mobileBack.classList.remove("visible");
      mobileTitle.textContent = "Equipment";
    }
  });

  function showSubcategories(category, level) {
    document.querySelectorAll(".subcategory-content").forEach((content) => {
      content.classList.remove("active");
    });

    const targetContent = document.querySelector(
      `.subcategory-content[data-category="${category}"]`
    );
    if (targetContent) {
      targetContent.classList.add("active");
      currentLevel = level;
    }
  }

  function navigateToLevel(level) {
    if (level === 1) {
      megaMenu.classList.remove("active");
      resetNavigation();
      return;
    }

    while (
      navigationStack.length > 0 &&
      navigationStack[navigationStack.length - 1].level > level
    ) {
      navigationStack.pop();
    }

    const targetState = navigationStack[navigationStack.length - 1];
    if (targetState) {
      showSubcategories(targetState.category, targetState.level);
      if (window.innerWidth <= 768) {
        mobileTitle.textContent = targetState.title;
      }
    }
  }

  function resetNavigation() {
    currentLevel = 1;
    navigationStack = [];

    const firstCategory = document.querySelector(".category-list a");
    if (firstCategory) {
      document
        .querySelectorAll(".category-list a")
        .forEach((a) => a.classList.remove("active"));
      firstCategory.classList.add("active");
      showSubcategories(firstCategory.dataset.category, 2);
    }
  }

  // Function to handle caret rotation
  function updateCaret() {
    if (megaMenu.classList.contains("active")) {
      caret.style.transform = "rotate(-88deg)";
    } else {
      caret.style.transform = "rotate(0deg)";
    }
  }

  // Initial call
  updateCaret();

  // Add observer to watch for class changes on mega menu
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.attributeName === "class") {
        updateCaret();
      }
    });
  });

  // Start observing the mega menu for class changes
  observer.observe(megaMenu, {
    attributes: true,
  });

  // Add an event listener to close the menu when clicking outside
  document.addEventListener("click", function (event) {
    // If the menu is open and the click is outside the menu and not on the trigger
    if (
      megaMenu.classList.contains("active") &&
      !megaMenu.contains(event.target) &&
      !equipmentTrigger.contains(event.target)
    ) {
      megaMenu.classList.remove("active");
      resetNavigation();
    }
  });
});

// The rest of your existing code...
// Simple breadcrumb click handler for mobile
document.addEventListener("click", function (e) {
  const breadcrumbItem = e.target.closest(".breadcrumb span[data-level]");
  if (breadcrumbItem && window.innerWidth <= 768) {
    const level = parseInt(breadcrumbItem.dataset.level);

    // If clicking level 2 on mobile
    if (level === 2) {
      // Remove active class from all subcategory content
      document.querySelectorAll(".subcategory-content").forEach((content) => {
        content.classList.remove("active");
      });
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  // Get all back and close buttons
  const backButtons = document.querySelectorAll(".mobile-back");
  const closeButtons = document.querySelectorAll(".mobile-close");

  // Add click handlers to all back buttons
  backButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const megaMenu = document.querySelector(".mega-menu");
      const navCategories = document.querySelector(".nav-categories");

      // If we're in the main navigation menu
      if (navCategories.classList.contains("active")) {
        navCategories.classList.remove("active");
        document.body.classList.remove("menu-open");
        return;
      }

      // If we're in the mega menu
      if (megaMenu.classList.contains("active")) {
        // Find any subcategory content that's currently shown
        const activeContent = document.querySelector(
          '.subcategory-content[style*="translateX(0"]'
        );
        if (activeContent) {
          activeContent.style.transform = "translateX(-100%)";
          return;
        }

        // If no active subcategory, close the mega menu
        megaMenu.classList.remove("active");
      }
    });
  });

  // Add click handlers to all close buttons
  closeButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const megaMenu = document.querySelector(".mega-menu");
      const navCategories = document.querySelector(".nav-categories");

      // Reset everything
      megaMenu.classList.remove("active");
      navCategories.classList.remove("active");
      document.body.classList.remove("menu-open");

      // Reset all subcategory panels
      document.querySelectorAll(".subcategory-content").forEach((content) => {
        content.style.transform = "translateX(-100%)";
      });
    });
  });
});

// Add event listener for clicks outside the menu
document.addEventListener("click", function (event) {
  const navCategories = document.querySelector(".nav-categories");
  const megaMenu = document.querySelector(".mega-menu");
  const mobileToggle = document.querySelector(".mobile-toggle");
  const equipmentTrigger = document.querySelector(".equipment-trigger");
  const isMobile = window.innerWidth <= 768;

  // Check if the navbar or mega menu is open
  if (
    navCategories.classList.contains("active") ||
    megaMenu.classList.contains("active")
  ) {
    // Check if click is outside the navbar and mega menu and not on any of the toggle buttons
    const clickedInside =
      navCategories.contains(event.target) ||
      megaMenu.contains(event.target) ||
      mobileToggle.contains(event.target) ||
      (equipmentTrigger && equipmentTrigger.contains(event.target));

    if (!clickedInside) {
      // Close the menus
      navCategories.classList.remove("active");
      megaMenu.classList.remove("active");
      document.body.classList.remove("menu-open");

      // Reset all subcategory panels - only apply transform on mobile
      document.querySelectorAll(".subcategory-content").forEach((content) => {
        if (isMobile) {
          content.style.transform = "translateX(-100%)";
        } else {
          // Clear transforms on desktop
          content.style.transform = "";
        }
      });
    }
  }
});
